import React, {useEffect} from 'react';
import {Route, Switch, useLocation} from "react-router-dom";
import OverviewReport from "../components/ReportType/OverviewReport";
import PageReport from "./ReportType/PageReport";
import SessionChatReport from "./ReportType/SessionChatReport";
import StaffReport from "./ReportType/StaffReport";
import CustomerReport from "./ReportType/CustomerReport";
import AdsReport from "./ReportType/AdsReport";
import TagReport from "./ReportType/TagReport";
import RangePickerCustom from "../../../components/RangePickerCustom";

const ContentReport = () => {

    const location = useLocation();

    const getTitlePage = () => {
        if(location.pathname === '/report'){
            return 'Tổng quan';
        }
        else if(location.pathname === '/report/page'){
            return 'Trang';
        }
        else if(location.pathname === '/report/session'){
            return 'Cuộc hội thoại';
        }
        else if(location.pathname === '/report/staff'){
            return 'Nhân viên';
        }
        else if(location.pathname === '/report/customer'){
            return 'Khách hàng';
        }
        else if(location.pathname === '/report/ads'){
            return 'Quảng cáo';
        }
        else if(location.pathname === '/report/tag'){
            return 'Thẻ hội thoại';
        }
    }

    useEffect(() => {

    }, []);

    return (
        <div className='page-statistic-content'>
            <div className='page-statistic-content-body'>
                <div className='overview-statistic'>
                    <div className="overview-statistic-header">
                        <div className="title">{getTitlePage()}</div>
                        <div className="filter d-flex">
                            <RangePickerCustom/>
                        </div>
                    </div>
                    <div className="main-content">
                        <Switch>
                            <Route exact path="/report" component={props => <OverviewReport {...props} />} />
                            <Route exact path="/report/page" component={props => <PageReport {...props} />} />
                            <Route exact path="/report/session" component={props => <SessionChatReport {...props} />} />
                            <Route exact path="/report/staff" component={props => <StaffReport {...props} />} />
                            <Route exact path="/report/customer" component={props => <CustomerReport {...props} />} />
                            <Route exact path="/report/ads" component={props => <AdsReport {...props} />} />
                            <Route exact path="/report/tag" component={props => <TagReport {...props} />} />
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContentReport;
